import moment from "moment-timezone";

// const percent = dec => `${(dec * 100).toFixed(0)}%`;
const percent = dec => `${(dec)}%`;// since we get back 0.5 for 0.5% ...
const dateNoSeconds = d => (d ? `${d.toLocaleDateString()} ${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}` : '');
const momentDateNoSeconds = d => d.format("M/DD/yyyy hh:mm A");
const date = d => d.format ? momentDateNoSeconds(d) : dateNoSeconds(d);
const timeOnly = d => (d ? d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '');
const dateOnly = d => (d ? d.toLocaleDateString() : '');
const timezone = d => (d ? d.toLocaleDateString() : '');

const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const dateLongMonthNoYear = d => (d ? `${monthNames[d.getMonth()]} ${d.getDate()} at ${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}` : '');
const dateLongMonthNoYearNoTime = d => (d ? `${monthNames[d.getMonth()]} ${d.getDate()}` : '');
const dateLongMonthWithDayNoYear = d => (d ? `${dayNames[d.getDay()]}, ${monthNames[d.getMonth()]} ${d.getDate()} @ ${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}` : '');
const dateMonthDayOnly = d => (d ? `${dayNames[d.getDay()]}, ${monthNames[d.getMonth()]} ${d.getDate()}` : '');
const shortDateNoYear = d => (d ? `${monthNames[d.getMonth()].substr(0,3)} ${d.getDate()}` : '');
const dateMonthDayOnlyUTC = d => (d ? `${dayNames[d.getUTCDay()]}, ${monthNames[d.getUTCMonth()]} ${d.getUTCDate()}` : '');
const asMoment = (val, args) => val ? moment(val) : null;
const format = (m, args) => m ? m.format(args) : null;
const withTimeZone = (m, args) => m ? moment.tz(m, moment.tz.guess()) : null;
const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}
const toUpperCase = (s) => {
  if (typeof s !== 'string') return ''
  return s.toUpperCase();
}

const datastr = (val) => {
  let bytes = parseInt(val);
  if (bytes) {
    const thresh = 1000;
    const units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    if (Math.abs(bytes) < thresh) {
      return `${bytes} B`;
    }

    let u = -1;
    do {
      bytes /= thresh;
      ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return `${bytes.toFixed(1)} ${units[u]}`;
  }
  return '';
};

const currency = (value) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });
  return formatter.format(value);
};

const number = (value) => {
  const comma = ',';
  let number = value;
  number = Math.abs(number).toFixed(0);
  const i = `${parseInt(number, 10)}`;
  /* eslint no-cond-assign: 0 */
  /* eslint no-use-before-define: 0 */
  let j = (j = i.length) > 3 ? j % 3 : 0;
  return `${(j ? i.substr(0, j) + comma : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${comma}`)}`;
};

export default {
  install(Vue) {
    Vue.filter('withTimeZone', withTimeZone);
    Vue.filter('asMoment', asMoment);
    Vue.filter('format', format);
    Vue.filter('date', date);
    Vue.filter('format', format);
    Vue.filter('dateNoSeconds', dateNoSeconds);
    Vue.filter('dateLongMonthNoYear', dateLongMonthNoYear);
    Vue.filter('dateLongMonthNoYearNoTime', dateLongMonthNoYearNoTime);
    Vue.filter('dateLongMonthWithDayNoYear', dateLongMonthWithDayNoYear);
    Vue.filter('dateMonthDayOnly', dateMonthDayOnly);
    Vue.filter('dateMonthDayOnlyUTC', dateMonthDayOnlyUTC);
    Vue.filter('shortDateNoYear', shortDateNoYear);

    Vue.filter('dateOnly', dateOnly);
    Vue.filter('timezone', timezone);
    Vue.filter('timeOnly', timeOnly);
    Vue.filter('currency', currency);
    Vue.filter('number', number);
    Vue.filter('percent', percent);
    Vue.filter('datastr', datastr);

    Vue.filter('capitalize', capitalize);
    Vue.filter('toUpperCase', toUpperCase);
  },
};
